<template>
    <div class="container-fluid">
        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row mt-3 mb-n3">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>

        <!-- Shop Info -->
        <div v-if="myShop && user" class="row my-5">
            <div class="col-12 pl-0">
                <h5>{{myShop.shopName}} <i @click="gotoGeneralPage" class="far fa-edit ml-2 fa-sm clickable"></i></h5>
                <p class="mt-4 mb-2">
                    Shop Handle: 
                    <router-link :to="{ name: 'user-handle', params: { handle: user.userHandle } }">
                        <span class="text-dark-green">@<b>{{user.userHandle}}</b></span>
                    </router-link>
                    <router-link :to="{ name: 'settings', query: { handle: null } }">
                        <i class="far fa-edit ml-2 fa-sm"></i>
                    </router-link>
                </p>
                <p class="mt-4 mb-2 text-capitalize">
                    Managed By: 
                    <router-link :to="{ name: 'lookup-handle', params: { handle: user.userHandle } }">
                        {{user.name}}
                    </router-link>
                </p>
                <p class="mt-4 mb-2">Created: {{myShop.joined | moment("MMM D YYYY h:m:s A")}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: "ShopInfo",
    data() {
        return {
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        gotoGeneralPage (event) {
            this.$router.push({
                name: 'shop-settings',
                query: { general: null }
            })
            this.$emit('gotoGeneral', true)
        },
    },
    computed: {
        ...mapGetters(['user', 'userShop']),
        myShop() {
            if(this.userShop && this.userShop !== null){
                return this.userShop
            }
            return false
        },
    },
}
</script>